import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { PinnedTilesComponent } from '../pinned-tiles/pinned-tiles.component';
import { Tile, TileComponent } from '../../../widgets/tile/tile.component';
import { IPinnedTile, TileService } from '../../../widgets/services/tile.service';
import { AppToastService } from '../../../widgets/services/app-toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { promises } from 'dns';

@Component({
  selector: 'app-pinned-tile-container',
  standalone: true,
  imports: [TileComponent, FormsModule, CommonModule, DragDropModule],
  templateUrl: './pinned-tile-container.component.html',
  styleUrls: ['./pinned-tile-container.component.scss']
})
export class PinnedTileContainerComponent {
  @Input() tiles: Tile[] = [];
  @Input() size: string = "xlarge";
  @Input() draggable: boolean = true;
  @Input() tileTemplate: TemplateRef<any> | null = null;
  @Input() showAdd: boolean = false;

  @Output() tilePinnedChange = new EventEmitter<Tile>();
  @Output() sortOrderChanged = new EventEmitter<ITileOrder[]>();
  @Output() addNew = new EventEmitter();
  arrangedOrders!: string;
  pinnedTiles: IPinnedTile[] = [];

  constructor(private service: TileService, private pinTile: PinnedTilesComponent, private toaster: AppToastService) {
  }

  pinnedChange(event: Tile) {
    // Just bubble up the event
    this.tilePinnedChange.emit(event);
    this.delay(300).then(() => this.getData());
    this.addTileToast(event);


  }
  delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  getData() {
    this.pinTile.tiles = [];
    this.service.getCurrentUser().then((data: any) => {
      this.pinTile.getPinnedData(data.emailAddress);
    });   
  }

  drop(event: CdkDragDrop<any>) {
    let oldIndex = event.previousContainer.data.index;
    let newIndex = event.container.data.index;

    if (oldIndex == newIndex) {
      return;
    }

    if (newIndex == 999) {
      newIndex = this.tiles.length;
    }

    if (oldIndex < newIndex) {
      newIndex--;
    }

    this.arraymove(this.tiles, oldIndex, newIndex);

    this.sortOrderChanged.emit(this.getTileOrders());
    this.service.OrderTile(this.getTileOrders());
  }

  getTileOrders(): any {
    let tileOrders: ITileOrder[] = [];

    for (var i = 0; i < this.tiles.length; i++) {
      tileOrders.push({ id: this.tiles[i].id, order: i });


    }
    return tileOrders;
  }

  arraymove(arr: any[], fromIndex: number, toIndex: number) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  addClick() {
    this.addNew.emit();
  }
  addTileToast(event: Tile) {
    let title = (event.data.text == undefined) ? event.data.name : event.data.text;
    //this.toaster.show('Tile Pinned', 'Tile ' + event.title + ', with id: ' + event.id + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);
    this.toaster.show('Tile Pinned', 'Tile ' + title + ', with type: ' + event.title + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);
  }
}

export interface ITileOrder {
  id: string;
  order: number;
}


